/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const topSearchDataLayer = {
    /**
     * Push search data to the data layer.
     *
     * @param {Array} products - List of products.
     * @param {Array} terms - Search terms.
     * @param {string} queryPhrase - Search query phrase.
     */
    dataLayerPushData(products, terms, queryPhrase) {
        const gtmData = {
            event: 'search',
            method: 'suggest',
            count: products?.length || 0,
            suggest: terms,
            search_term: queryPhrase,
            genderarea: hyva.getCookie('mey-gender') === 'm' ? 'male' : 'female'
        }

        yireoGoogleTagManager2Logger('page event "search" (js)', gtmData)
        dataLayer.push(gtmData)

        const gtmSuggestItems = products
            .filter(item => Object.prototype.hasOwnProperty.call(item, 'gtmItem'))
            .map(item => item.gtmItem)

        const gtmDataView = {
            event: 'view_item_list',
            ecommerce: {
                item_list_id: 'suggest',
                item_list_name: 'suggest',
                item_list_path: `suggest/${queryPhrase}`,
                items: gtmSuggestItems
            }
        }

        yireoGoogleTagManager2Logger('page event "view_item_list" (js)', gtmDataView)
        dataLayer.push(gtmDataView)
    }
}

export default topSearchDataLayer
